import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTypeRenamingFailedAction = {
	type: 'DOCUMENT_TYPE_RENAMING_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTypeRenamingFailedAction => ({
	type: 'DOCUMENT_TYPE_RENAMING_FAILED',
	payload,
});
